import React, { useState } from 'react';
import { Accordion, AccordionSummary } from '@mui/material';
import { Icon } from '../../../ui';
import { useTasksActions } from '../hooks/useTasksActions';
import { useTasks } from '../hooks/useTasksState';

import AnswersList from './AnswersList';
import EditFeedback from './EditFeedback';

const ContentWrapper = ({ item, userName, children, courseId, taskType }) => {
  const [expanded, setExpanded] = useState();
  const [modalContent, setModalContent] = useState({});

  const { saveTaskFeedback } = useTasksActions();
  const { refetch } = useTasks({ courseId }, { skip: !courseId });

  const onCloseEditFeedback = () => {
    setModalContent({})
  }

  const handleOpenFeedback = (options) => {
    setModalContent({ ...options })
  }

  const expandContent = (id) => (event, isExpanded) => {
    setExpanded(isExpanded ? id : false);
  };

  const saveFeedback = async (feedbackData) => {
    await saveTaskFeedback({ feedbackData, courseId });
    // Once feedback is saved and success message is shown, fetch updated tasks
    refetch();
    onCloseEditFeedback();
  };

  return (
    <>
      <Accordion
        sx={{ width: '100%' }}
        onChange={expandContent(item.id)}
        expanded={+expanded === +item.id}
      >
        <AccordionSummary expandIcon={<Icon.ExpandMore />}>
          {children}
        </AccordionSummary>
        <AnswersList
          answers={item.answers}
          parentId={item.id}
          taskType={taskType}
          userName={userName}
          handleOpenFeedback={handleOpenFeedback}
        />
      </Accordion>
      <EditFeedback
        open={!!modalContent.response}
        onClose={onCloseEditFeedback}
        content={modalContent}
        onAccept={saveFeedback}
      />
    </>
  );
};

export default ContentWrapper;
